import { useEffect } from 'react';
export const useActionManager = (actionManager, actionHistoryChangedHandler) => {
  useEffect(() => {
    actionManager.addEventListener('actionHistoryChanged', actionHistoryChangedHandler);
    return () => {
      actionManager.removeEventListener('actionHistoryChanged', actionHistoryChangedHandler);
    };
  }, [actionHistoryChangedHandler, actionManager]);
};
export const useActionManagers = (actionManagers, actionHistoryChangedHandler) => {
  useEffect(() => {
    for (const actionManager of actionManagers) {
      actionManager.addEventListener('actionHistoryChanged', actionHistoryChangedHandler);
    }
    return () => {
      for (const actionManager of actionManagers) {
        actionManager.removeEventListener('actionHistoryChanged', actionHistoryChangedHandler);
      }
    };
  }, [actionHistoryChangedHandler, actionManagers]);
};
export const getUndoRedoProps = actionManager => {
  return {
    undoProps: getUndoOrRedoProps(actionManager, 'undo'),
    redoProps: getUndoOrRedoProps(actionManager, 'redo')
  };
};
const getUndoOrRedoProps = (actionManager, type) => {
  const actions = [...(type === 'undo' ? actionManager.getUndoActions() : actionManager.getRedoActions())].reverse();
  return {
    sections: [{
      items: actions.map(action => ({
        text: action.getDisplayString()
      }))
    }],
    disabled: actions.length === 0,
    onPress: type === 'undo' ? () => actionManager.undoAction() : () => actionManager.redoAction(),
    onItemSelected: type === 'undo' ? ([[_sectionIndex, itemIndex]]) => actionManager.undoActionHistoryTo(actions[itemIndex]) : ([[_sectionIndex, itemIndex]]) => actionManager.redoActionHistoryTo(actions[itemIndex])
  };
};
//# sourceMappingURL=useActionManager.js.map